import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-white border-t border-gray-200 py-3 px-8 mt-auto animate-fade-in" data-id="element-192">
      <div className="max-w-7xl mx-auto" data-id="element-193">
        <div className="flex items-center justify-center gap-2" data-id="element-194">
          {/* Sprinklenet Robot Avatar */}
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1FrxAsdV23omiQNLw7zxz9/Sprinklenet_AI_Square_800px_Robot_Avatar.jpg" alt="Sprinklenet Robot Avatar" className="w-3.5 h-3.5 rounded-lg shadow-sm transition-transform duration-200 hover:scale-110 object-cover" data-id="element-195" />
          {/* Footer Text - Unified Subtle Style */}
          <div className="flex items-center gap-1.5" data-id="element-196">
            <p className="text-xs text-gray-500" data-id="element-197">Built and Powered by</p>
            <a href="https://sprinklenet.com" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-500 font-medium hover:text-blue-600 transition-colors duration-200" data-id="element-198">
              Sprinklenet Knowledge Spaces
            </a>
            <span className="text-gray-400 mx-1" data-id="element-199">•</span>
            <span className="text-xs text-gray-500" data-id="element-200">
              Q4 2025 Demo Version • Enterprise Platform
            </span>
          </div>
        </div>
      </div>
    </footer>;
}